/* eslint-disable vue/component-name-in-template-casing */
import Signup from "@/pages/public/Signup";
import Login from "@/pages/public/Login";
import Forgotpassword from "@/pages/public/Forgotpassword";
import Passwordreset from "@/pages/public/Passwordreset";
import Thankyou from "@/pages/public/Thankyou";
import CyberSecurity from '@/pages/public/CyberSecurity';
import Authentication from "@/pages/public/Authentication";
import PasswordSet from "@/pages/public/PasswordSet";
import GoogleComplete from "@/pages/public/GoogleComplete";

const routes = [
  {
    path: "/signup",
    name: "Sign Up",
    component: Signup
  },
  {
    path: "/forgot-password",
    name: "Forgot Password",
    component: Forgotpassword
  },
  {
    path: "/password-reset",
    name: "Password Reset",
    component: Passwordreset
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/thankyou",
    name: "Thankyou",
    component: Thankyou
  },
  {
    path: "/courses/cyber-security",
    name: 'Cyber Security',
    component: CyberSecurity,
  },
  {
    path: "/sso/:userId?/:provider?/:providerId?/:state?",
    name: "Authentication",
    component: Authentication
  },
  {
    path: "/password-set",
    name: "Set Password",
    component: PasswordSet
  },
  {
    path: "/google-complete",
    name: "GoogleComplete",
    component: GoogleComplete
  },
];

export default routes.map(route => {
  const meta = {
    public: true,
    onlyLoggedOut: true
  };
  return { ...route, meta };
});
